export default "__VITE_ASSET__CXxMqZhd__"